/**
 * Lee la duración de un archivo de audio desde una URL probando solo el header
 * (preload='metadata'). El browser descarga unos pocos KB; no baja el archivo
 * completo. Latencia ~100-300 ms.
 *
 * Devuelve la duración en segundos. Rechaza si el archivo no carga o no expone
 * una duración finita > 0.
 */
export const readAudioDuration = (url: string): Promise<number> =>
  new Promise((resolve, reject) => {
    const el = document.createElement('audio');
    el.preload = 'metadata';
    el.src = url;
    el.addEventListener('loadedmetadata', () => {
      if (isFinite(el.duration) && el.duration > 0) resolve(el.duration);
      else reject(new Error('Audio metadata missing duration'));
    });
    el.addEventListener('error', () => reject(new Error('Audio failed to load')));
  });
